// src/locales/ta/purchaseOrder.js
export const purchaseOrder = {
  // Page titles and navigation
  createPurchaseOrder: 'கொள்முதல் ஆணையை உருவாக்கவும்',
  createPurchaseOrderDescription: 'சரக்கு பட்டியலுக்கான புதிய கொள்முதல் ஆணையை உருவாக்கவும்',
  editPurchaseOrder: 'கொள்முதல் ஆணையைத் திருத்தவும்',
  editPurchaseOrderDescription: 'கொள்முதல் ஆணை விவரங்களைப் புதுப்பிக்கவும்',
  purchaseOrderDetails: 'கொள்முதல் ஆணை விவரங்கள்',
  backToPurchaseOrders: 'கொள்முதல் ஆணைகளுக்குத் திரும்பவும்',
  allPurchaseOrders: 'அனைத்து கொள்முதல் ஆணைகள்',
  addPurchaseOrder: 'கொள்முதல் ஆணையைச் சேர்க்கவும்',

  // List page
  manageAndTrackPurchaseOrders: 'சரக்கு பட்டியலுக்கான அனைத்து கொள்முதல் ஆணைகளை நிர்வகித்தல் மற்றும் கண்காணித்தல்',
  noPurchaseOrdersYet: 'இதுவரை கொள்முதல் ஆணைகள் இல்லை',
  noPurchaseOrdersYetDescription: 'சரக்கு கொள்முதல்களை நிர்வகிக்கத் தொடங்க உங்கள் முதல் கொள்முதல் ஆணையை உருவாக்கவும்.',
  noPurchaseOrdersFound: 'கொள்முதல் ஆணைகள் எதுவும் கிடைக்கவில்லை',
  noPurchaseOrdersFoundDescription: 'உங்கள் தற்போதைய வடிப்பான்களுடன் பொருந்தும் கொள்முதல் ஆணைகள் இல்லை. உங்கள் தேடல் அளவுகோல்களைச் சரிசெய்யவும்.',
  createFirstPurchaseOrder: 'முதல் கொள்முதல் ஆணையை உருவாக்கவும்',
  searchByPoNumber: 'PO எண்ணின் மூலம் தேடவும்...',
  allWarehouses: 'அனைத்து கிடங்குகள்',
  allSuppliers: 'அனைத்து சப்ளையர்கள்',
  allStatuses: 'அனைத்து நிலைகள்',
  dateRange: 'தேதி வரம்பு',
  totalItems: 'மொத்த பொருட்கள்',
  receiveOrder: 'ஆணையைப் பெறவும்',

  // Edit messages
  loadingOrder: 'ஆணை ஏற்றப்படுகிறது',
  cannotEditOrder: 'இந்த கொள்முதல் ஆணையைத் திருத்த முடியாது',
  confirmUpdate: 'இந்த கொள்முதல் ஆணையைப் புதுப்பிக்க விரும்புகிறீர்களா?',
  confirmUpdateTitle: 'புதுப்பிப்பை உறுதிப்படுத்தவும்',
  purchaseOrderUpdated: 'கொள்முதல் ஆணை {{orderNumber}} வெற்றிகரமாகப் புதுப்பிக்கப்பட்டது',
  failedToUpdate: 'கொள்முதல் ஆணையைப் புதுப்பிக்க முடியவில்லை',
  failedToLoadOrder: 'கொள்முதல் ஆணையை ஏற்ற முடியவில்லை',
  updateOrder: 'ஆணையைப் புதுப்பிக்கவும்',
  updateWarning: 'இது புதிய விவரங்களுடன் கொள்முதல் ஆணையைப் புதுப்பிக்கும்.',
  updatingOrder: 'புதுப்பிக்கப்படுகிறது...',
  orderNotEditable: 'இந்த ஆணையைத் திருத்த முடியாது ({{status}})',
  
  // Form sections
  basicInformation: 'அடிப்படை தகவல்',
  purchaseOrderItems: 'கொள்முதல் ஆணை பொருட்கள்',
  financialDetails: 'நிதி விவரங்கள்',
  
  // Basic information fields
  warehouse: 'கிடங்கு',
  warehouseRequired: 'கிடங்கு தேவை',
  selectWarehouse: 'கிடங்கைத் தேர்ந்தெடுக்கவும்',
  
  supplier: 'சப்ளையர்',
  supplierRequired: 'சப்ளையர் தேவை',
  selectSupplier: 'சப்ளையரைத் தேர்ந்தெடுக்கவும் அல்லது தேடவும்',
  createNewSupplier: 'புதிய சப்ளையரை உருவாக்கவும்',
  supplierName: 'சப்ளையர் பெயர்',
  supplierContact: 'தொடர்பு நபர்',
  supplierEmail: 'மின்னஞ்சல்',
  supplierPhone: 'தொலைபேசி',
  changeSupplier: 'சப்ளையரை மாற்றவும்',
  createSupplierWithName: '"{{name}}" ஐ உருவாக்கவும்',
  
  orderDate: 'ஆணை தேதி',
  orderDateRequired: 'ஆணை தேதி தேவை',
  
  expectedDeliveryDate: 'எதிர்பார்க்கப்படும் விநியோக தேதி',
  expectedDeliveryDateOptional: 'எதிர்பார்க்கப்படும் விநியோக தேதி (விருப்பத்தேர்வு)',
  
  status: 'நிலை',
  statusDraft: 'வரைவு',
  statusPending: 'நிலுவையில்',
  statusReceived: 'பெறப்பட்டது',
  statusPartial: 'பகுதியாகப் பெறப்பட்டது',
  statusCancelled: 'ரத்து செய்யப்பட்டது',
  
  notes: 'குறிப்புகள்',
  notesPlaceholder: 'இந்த கொள்முதல் ஆணை பற்றிய கூடுதல் குறிப்புகளைச் சேர்க்கவும்...',
  
  autoReceive: 'தானாக பெறவும்',
  autoReceiveTooltip: 'உருவாக்கப்படும்போது உடனடியாக இந்த ஆணையைப் பெறப்பட்டதாகக் குறிக்கவும் மற்றும் சரக்கைப் புதுப்பிக்கவும்',
  autoReceiveWarning: 'இது உடனடியாக சரக்கு பட்டியலில் பொருட்களைச் சேர்க்கும்',
  
  // Items section
  searchProducts: 'தயாரிப்புகளைத் தேடவும்',
  searchProductsPlaceholder: 'பெயர், SKU, அல்லது பார்கோடு மூலம் தேடவும்...',
  addItem: 'பொருளைச் சேர்க்கவும்',
  removeItem: 'பொருளை அகற்றவும்',
  atLeastOneItemRequired: 'குறைந்தது ஒரு பொருள் தேவை',
  
  product: 'தயாரிப்பு',
  productRequired: 'தயாரிப்பு தேவை',
  selectProduct: 'தயாரிப்பைத் தேர்ந்தெடுக்கவும்',
  
  quantity: 'அளவு',
  quantityRequired: 'அளவு தேவை',
  quantityMinimum: 'அளவு 0 ஐ விட அதிகமாக இருக்க வேண்டும்',
  
  unitPrice: 'அலகு விலை',
  unitPriceRequired: 'அலகு விலை தேவை',
  unitPriceMinimum: 'அலகு விலை 0 ஐ விட அதிகமாக அல்லது சமமாக இருக்க வேண்டும்',
  
  lineTotal: 'வரி மொத்தம்',
  lineNotes: 'பொருள் குறிப்புகள்',
  lineNotesPlaceholder: 'இந்த பொருளுக்கான குறிப்புகளைச் சேர்க்கவும்...',
  
  // Financial details
  subtotal: 'உப மொத்தம்',
  extraCharges: 'கூடுதல் கட்டணங்கள்',
  extraChargesPlaceholder: 'எ.கா: 500.00',
  extraChargesDescription: 'கூடுதல் கட்டணங்கள் விவரம்',
  extraChargesDescriptionPlaceholder: 'கூடுதல் கட்டணங்களை விவரிக்கவும் (விநியோகம், வரி, போன்றவை)',
  
  discountAmount: 'தள்ளுபடி தொகை',
  discountAmountPlaceholder: 'எ.கா: 100.00',
  discountDescription: 'தள்ளுபடி விவரம்',
  discountDescriptionPlaceholder: 'தள்ளுபடி காரணத்தை விவரிக்கவும்',
  
  grandTotal: 'மொத்த தொகை',
  
  // Product search
  noProductsFound: 'தயாரிப்புகள் கிடைக்கவில்லை',
  searchingProducts: 'தேடப்படுகிறது...',
  productSku: "SKU",
  productStock: 'தற்போதைய சரக்கு',
  productPrice: 'செலவு விலை',
  
  // Supplier dialog
  supplierDialogTitle: 'புதிய சப்ளையரை உருவாக்கவும்',
  supplierDialogDescription: 'உங்கள் அமைப்பில் புதிய சப்ளையரைச் சேர்க்கவும்',
  supplierNameRequired: 'சப்ளையர் பெயர் தேவை',
  supplierNamePlaceholder: 'சப்ளையர் நிறுவனத்தின் பெயரை உள்ளிடவும்',
  supplierContactPlaceholder: 'தொடர்பு நபரின் பெயரை உள்ளிடவும்',
  supplierEmailPlaceholder: 'சப்ளையர் மின்னஞ்சலை உள்ளிடவும்',
  supplierPhonePlaceholder: 'சப்ளையர் தொலைபேசியை உள்ளிடவும்',
  supplierCreating: 'சப்ளையர் உருவாக்கப்படுகிறது...',
  searchingSuppliers: 'சப்ளையர்கள் தேடப்படுகிறார்கள்...',
  
  // Actions
  saveAsDraft: 'வரைவாக சேமிக்கவும்',
  submitOrder: 'ஆணையைச் சமர்ப்பிக்கவும்',
  updateOrder: 'ஆணையைப் புதுப்பிக்கவும்',
  cancel: 'ரத்து செய்',
  
  // Success messages
  purchaseOrderCreated: 'கொள்முதல் ஆணை {{orderNumber}} வெற்றிகரமாக உருவாக்கப்பட்டது',
  purchaseOrderCreatedAndReceived: 'கொள்முதல் ஆணை {{orderNumber}} வெற்றிகரமாக உருவாக்கப்பட்டு பெறப்பட்டது',
  purchaseOrderUpdated: 'கொள்முதல் ஆணை வெற்றிகரமாகப் புதுப்பிக்கப்பட்டது',
  purchaseOrderSaved: 'கொள்முதல் ஆணை வரைவாக சேமிக்கப்பட்டது',
  supplierCreated: 'சப்ளையர் வெற்றிகரமாக உருவாக்கப்பட்டார்',
  
  // Error messages
  failedToCreate: 'கொள்முதல் ஆணையை உருவாக்க முடியவில்லை',
  failedToUpdate: 'கொள்முதல் ஆணையைப் புதுப்பிக்க முடியவில்லை',
  failedToLoadData: 'தேவையான தரவை ஏற்ற முடியவில்லை',
  failedToLoadOrder: 'கொள்முதல் ஆணையை ஏற்ற முடியவில்லை',
  failedToCreateSupplier: 'சப்ளையரை உருவாக்க முடியவில்லை',
  cannotEditReceived: 'பெறப்பட்ட கொள்முதல் ஆணையைத் திருத்த முடியாது',
  cannotEditCancelled: 'ரத்து செய்யப்பட்ட கொள்முதல் ஆணையைத் திருத்த முடியாது',
  cannotEditActiveReceipts: 'இந்த கொள்முதல் ஆணையில் செயலில் உள்ள GRN அல்லது விநியோகஸ்தருக்கு திருப்பி அனுப்பும் பதிவுகள் உள்ளன. திருத்துவதற்கு முன் அவற்றை ரத்து செய்யவும்.',
  
  // Validation messages
  pleaseFixErrors: 'சமர்ப்பிப்பதற்கு முன் பிழைகளை சரிசெய்யவும்',
  unsavedChanges: 'நீங்கள் சேமிக்காத மாற்றங்களைக் கொண்டுள்ளீர்கள். வெளியேற விரும்புகிறீர்களா?',
  confirmSubmit: 'இந்த கொள்முதல் ஆணையைச் சமர்ப்பிக்க விரும்புகிறீர்களா?',
  confirmSubmitTitle: 'சமர்ப்பிப்பை உறுதிப்படுத்தவும்',
  confirmDraft: 'இந்த கொள்முதல் ஆணையை வரைவாக சேமிக்கவா?',
  
  // Loading states
  loadingWarehouses: 'கிடங்குகள் ஏற்றப்படுகின்றன...',
  loadingSuppliers: 'சப்ளையர்கள் ஏற்றப்படுகிறார்கள்...',
  loadingProducts: 'தயாரிப்புகள் ஏற்றப்படுகின்றன...',
  loadingOrder: 'கொள்முதல் ஆணை ஏற்றப்படுகிறது...',
  loadingMessage: 'தேவையான தரவு ஏற்றப்படும் வரை காத்திருக்கவும்...',
  loadingOrderMessage: 'ஆணை தரவு ஏற்றப்படும் வரை காத்திருக்கவும்...',
  submittingOrder: 'ஆணை சமர்ப்பிக்கப்படுகிறது...',
  
  // Empty states
  noWarehousesAvailable: 'கிடங்குகள் கிடைக்கவில்லை',
  noSuppliersAvailable: 'சப்ளையர்கள் கிடைக்கவில்லை',
  noItemsAdded: 'இன்னும் பொருட்கள் சேர்க்கப்படவில்லை',
  addItemsToOrder: 'இந்த கொள்முதல் ஆணைக்கு பொருட்களைச் சேர்க்கவும்',
  
  // Tooltips and hints
  warehouseHint: 'சரக்கு பெறப்படும் கிடங்கைத் தேர்ந்தெடுக்கவும்',
  supplierHint: 'இந்த ஆணைக்கான சப்ளையரைத் தேடி தேர்ந்தெடுக்கவும்',
  orderDateHint: 'கொள்முதல் ஆணை உருவாக்கப்பட்ட தேதி',
  expectedDeliveryHint: 'பொருட்கள் விநியோகிக்கப்படும் எதிர்பார்க்கப்படும் தேதி',
  autoReceiveHint: 'ஆணை உருவாக்கப்படும்போது உடனடியாக சரக்கைப் புதுப்பிக்க இதைச் சரிபார்க்கவும்',
  
  // Table headers
  itemNumber: "#",
  itemProduct: 'தயாரிப்பு',
  itemQuantity: 'அளவு',
  itemUnitPrice: 'அலகு விலை',
  itemLineTotal: 'மொத்தம்',
  itemActions: 'செயல்கள்',
  
  // Currency
  currency: 'ரூ.',
  
  // Common
  required: 'தேவை',
  optional: 'விருப்பத்தேர்வு',
  loading: 'ஏற்றப்படுகிறது...',
  search: 'தேடு',
  create: 'உருவாக்கு',
  update: 'புதுப்பி',
  save: 'சேமி',
  delete: 'நீக்கு',
  view: 'பார்வை',
  edit: 'திருத்து',
  
  // Order number
  orderNumber: 'ஆணை எண்',
  poNumber: 'PO எண்',
  generatedOrderNumber: 'உருவாக்கப்பட்ட ஆணை எண்',

  // Receive action
  confirmReceiveTitle: "ஆர்டர் பெறுதலை உறுதிப்படுத்தவும்",
  confirmReceive: "இந்தக் கொள்முதல் ஆர்டரைப் பெறப்பட்டதாகக் குறிக்க விரும்புகிறீர்களா? அனைத்து பொருட்களும் முழுமையாகப் பெறப்பட்டு கையிருப்பு புதுப்பிக்கப்படும்.",
  receivingOrder: "பெறுகிறது...",
  purchaseOrderReceived: "கொள்முதல் ஆர்டர் {orderNumber} பெறப்பட்டதாகக் குறிக்கப்பட்டது",
  failedToReceive: "கொள்முதல் ஆர்டரைப் பெற முடியவில்லை",

  // Details page
  purchaseOrderDetailsDescription: "இந்தக் கொள்முதல் ஆர்டரின் முழு விவரங்களைப் பார்க்கவும்",
  orderInformation: "ஆர்டர் தகவல்",
  supplierInformation: "சப்ளையர் தகவல்",
  warehouseInformation: "கிடங்கு தகவல்",
  itemsOrdered: "ஆர்டர் செய்த பொருட்கள்",
  financialSummary: "நிதிச் சுருக்கம்",
  auditInformation: "தணிக்கைத் தகவல்",
  receivedQuantity: "பெறப்பட்ட அளவு",
  orderedQuantity: "ஆர்டர் செய்த அளவு",
  receivedBy: "பெற்றவர்",
  receivedDate: "பெறப்பட்ட தேதி",
  cancelledBy: "ரத்து செய்தவர்",
  cancelledAt: "ரத்து செய்த தேதி",
  cancellationReason: "ரத்து செய்வதற்கான காரணம்",
  noCancellationReason: "காரணம் வழங்கப்படவில்லை",
  confirmCancelTitle: "கொள்முதல் ஆர்டரை ரத்து செய்யவும்",
  confirmCancel: "இந்தக் கொள்முதல் ஆர்டரை ரத்து செய்ய விரும்புகிறீர்களா? இந்தச் செயலைத் திரும்பப் பெற முடியாது.",
  cancellationReasonLabel: "ரத்து செய்வதற்கான காரணம் (விருப்பத்தேர்வு)",
  cancellationReasonPlaceholder: "ரத்து செய்வதற்கான காரணத்தை உள்ளிடவும்...",
  cancellingOrder: "ரத்து செய்கிறது...",
  purchaseOrderCancelled: "கொள்முதல் ஆர்டர் {orderNumber} ரத்து செய்யப்பட்டது",
  failedToCancel: "கொள்முதல் ஆர்டரை ரத்து செய்ய முடியவில்லை",
  noNotes: "குறிப்புகள் இல்லை",
  contactPerson: "தொடர்பு நபர்",
  variation: "வகை",
  notSpecified: "குறிப்பிடப்படவில்லை",
  partiallyReceived: "பகுதியாகப் பெறப்பட்டது",
  fullyReceived: "முழுமையாகப் பெறப்பட்டது",
  notYetReceived: "இன்னும் பெறப்படவில்லை",

  // Export / Download
  downloadPdf: 'PDF பதிவிறக்கம்',
  downloadExcel: 'Excel பதிவிறக்கம்',
  downloading: 'பதிவிறக்கமாகிறது...',

  // Reverse action
  reverseOrder: 'ஆர்டரை திரும்பப் பெறுங்கள்',
  confirmReverseTitle: 'கொள்முதல் ஆர்டரை திரும்பப் பெறுங்கள்',
  confirmReverse: 'இது இந்த கொள்முதல் ஆர்டரால் செய்யப்பட்ட அனைத்து சரக்கு மாற்றங்களையும் நிரந்தரமாக திரும்பப் பெறும். பெறப்பட்ட அனைத்து அளவுகளும் சரக்கிலிருந்து அகற்றப்படும்.',
  confirmReverseTypeYes: 'இந்த செயலை உறுதிப்படுத்த YES என தட்டச்சு செய்யுங்கள்',
  confirmReverseTypePlaceholder: 'இங்கே YES தட்டச்சு செய்யுங்கள்',
  reversingOrder: 'திரும்பப் பெறுகிறது...',
  purchaseOrderReversed: 'கொள்முதல் ஆர்டர் {{orderNumber}} திரும்பப் பெறப்பட்டது',
  failedToReverse: 'கொள்முதல் ஆர்டரை திரும்பப் பெற முடியவில்லை',

  // Supplier payments (Payment Records section + Payments modal)
  paymentRecords: 'கட்டணப் பதிவுகள்',
  poTotal: 'கொள்முதல் ஆர்டர் மொத்தம்',
  payments: 'கட்டணங்கள்',
  paymentDetails: 'கட்டண விவரங்கள்',
  outstandingBalance: 'நிலுவைத் தொகை',
  debitNotePaymentMethod: 'டெபிட் குறிப்பு',
  selectDebitNote: 'டெபிட் குறிப்பைத் தேர்ந்தெடுக்கவும்',
  searchDebitNote: 'டெபிட் குறிப்புகளைத் தேடுங்கள்...',
  noAvailableDebitNotes: 'இந்த வழங்குநருக்கு டெபிட் குறிப்புகள் இல்லை',
  confirmPayment: 'கட்டணத்தை உறுதிப்படுத்தவும்',
  completePaymentFields: 'அனைத்து கட்டணப் புலங்களையும் நிரப்பவும்',
  paymentRecordedSuccess: 'கட்டணம் வெற்றிகரமாகப் பதிவு செய்யப்பட்டது',
  createGoodsReceivedNote: "GRN உருவாக்கவும்",
  createReturnToVendor: "RTV உருவாக்கவும்",
  recordPayment: "கட்டணத்தைப் பதிவு செய்யவும்",
  paymentRecordedSuccessfully: "கட்டணம் வெற்றிகரமாகப் பதிவு செய்யப்பட்டது",
  failedToRecordPayment: "கட்டணத்தைப் பதிவு செய்ய முடியவில்லை",
  paymentMethodRequired: "கட்டண முறையைத் தேர்ந்தெடுக்கவும்",
  paymentAmountRequired: "சரியான கட்டணத் தொகையை உள்ளிடவும்",
  paymentStatus: "கட்டணம்",
  paymentStatus_unpaid: "செலுத்தப்படவில்லை",
  paymentStatus_partial: "பகுதியாகச் செலுத்தப்பட்டது",
  paymentStatus_paid: "செலுத்தப்பட்டது",
  paidAmount: "செலுத்தியது",
  balanceAmount: "செலுத்த வேண்டிய நிலுவை",
  relatedDocuments: "தொடர்புடைய ஆவணங்கள்",
  goodsReceivedNotes: "பெறப்பட்ட பொருட்கள் குறிப்புகள்",
  returnsToVendor: "சப்ளையர் திரும்பல்கள்",
  debitNotes: "டெபிட் குறிப்புகள்",
  paymentHistory: "கட்டண வரலாறு",
  noRelatedDocuments: "இன்னும் இல்லை",
  paymentDate: "கட்டணத் தேதி",
  paymentMethod: "கட்டண முறை",
  paymentAmount: "தொகை",
  paymentReference: "குறிப்பு",
  activityHistory: "செயல்பாட்டு வரலாறு",
  noActivity: "இன்னும் செயல்பாடுகள் பதிவு செய்யப்படவில்லை",
  loadMore: "மேலும் ஏற்று",
  auditHistory: "தணிக்கை வரலாறு",
  totalChanges: "மொத்த மாற்றங்கள்",
  lastModified: "கடைசியாக மாற்றப்பட்டது",
  auditEmpty: "காலி",
  auditBy: "{{name}} மூலம்",
  auditTag_payment: "கட்டண பதிவு",
  auditTag_grn: "GRN",
  auditTag_rtv: "விற்பனையாளருக்கு திருப்பி அனுப்புதல்",
  auditTag_debitNote: "பற்று குறிப்பு",
  auditField_paymentDate: "கட்டண தேதி",
  previous: "முந்தைய",
  next: "அடுத்து",
  pageOf: "பக்கம் {{page}} / {{total}}",
  noPaymentRecords: "இன்னும் கட்டணங்கள் பதிவு செய்யப்படவில்லை",
  returnedToVendor: "விற்பனையாளருக்கு திருப்பி அனுப்பப்பட்டது",
  voided: "ரத்து செய்யப்பட்டது",
  audit_CREATE: "கொள்முதல் ஆர்டர் உருவாக்கப்பட்டது",
  audit_UPDATE: "கொள்முதல் ஆர்டர் புதுப்பிக்கப்பட்டது",
  audit_STATUS_CHANGED: "நிலை மாற்றப்பட்டது",
  audit_CANCEL: "கொள்முதல் ஆர்டர் ரத்து செய்யப்பட்டது",
  audit_RECEIVE_FULL: "முழுமையாகப் பெறப்பட்டது",
  audit_PAYMENT_ADDED: "கட்டணம் பதிவு செய்யப்பட்டது",
  audit_PAYMENT_UPDATED: "கட்டணம் புதுப்பிக்கப்பட்டது",
  audit_PAYMENT_REMOVED: "கட்டணம் நீக்கப்பட்டது",
  audit_GRN_CREATED: "பெறப்பட்ட பொருட்கள் குறிப்பு உருவாக்கப்பட்டது",
  audit_GRN_CANCELLED: "பெறப்பட்ட பொருட்கள் குறிப்பு ரத்து செய்யப்பட்டது",
  audit_RTV_CREATED: "சப்ளையர் திரும்பல் உருவாக்கப்பட்டது",
  audit_RTV_VOIDED: "சப்ளையர் திரும்பல் ரத்து செய்யப்பட்டது",
  audit_DEBIT_NOTE_ISSUED: "டெபிட் குறிப்பு வழங்கப்பட்டது",
  audit_DEBIT_NOTE_APPLIED: "டெபிட் குறிப்பு பயன்படுத்தப்பட்டது",
  audit_DEBIT_NOTE_CANCELLED: "டெபிட் குறிப்பு ரத்து செய்யப்பட்டது",
  auditField_purchaseOrderNumber: "ஆர்டர் எண்",
  auditField_status: "நிலை",
  auditField_grandTotal: "மொத்தத் தொகை",
  auditField_totalAmount: "துணைத் தொகை",
  auditField_extraCharges: "கூடுதல் கட்டணங்கள்",
  auditField_discountAmount: "தள்ளுபடி",
  auditField_orderDate: "ஆர்டர் தேதி",
  auditField_expectedDeliveryDate: "எதிர்பார்க்கப்படும் டெலிவரி",
  auditField_notes: "குறிப்புகள்",
  auditField_supplierName: "விநியோகஸ்தர்",
  auditField_extraChargesDescription: "கூடுதல் கட்டண குறிப்பு",
  auditField_discountDescription: "தள்ளுபடி குறிப்பு",
  auditField_autoReceive: "தானியங்கு பெறுதல்",
  auditField_warehouseName: "கிடங்கு",
  auditField_items: "பொருட்கள்",
  auditField_itemCount: "பொருட்கள்",
  auditField_amount: "தொகை",
  auditField_method: "கட்டண முறை",
  auditField_reference: "குறிப்பு",
  auditField_grnNumber: "GRN எண்",
  auditField_rtvNumber: "RTV எண்",
  auditField_debitNoteNumber: "டெபிட் குறிப்பு",
  auditField_totalDebitAmount: "டெபிட் தொகை",
  auditField_quantityReceived: "பெறப்பட்ட அளவு",
  auditField_sourceType: "மூலம்",
  auditField_proofUrl: "சான்று கோப்பு",
  auditField_quantity: "அளவு",
  auditField_unitPrice: "அலகு விலை",
  auditField_lineTotal: "வரி மொத்தம்",
  auditItemAdded: "பொருள் சேர்க்கப்பட்டது",
  auditItemRemoved: "பொருள் நீக்கப்பட்டது",
  auditItemUpdated: "பொருள் புதுப்பிக்கப்பட்டது",
  auditViewFile: "கோப்பைக் காண்க",
  auditLegacyItems: "பொருட்கள் புதுப்பிக்கப்பட்டன ({{count}}) — விவரங்கள் பதிவு செய்யப்படவில்லை",
  quantityMustBeGreaterThanZero: "அளவு குறைந்தது 1 ஆக இருக்க வேண்டும்",
  quantityMustBeWholeNumber: "அளவு முழு எண்ணாக இருக்க வேண்டும்",
  unitPriceRequired: "அலகு விலை தேவை",
  openFullDetails: "முழு விவரங்களைத் திற",
};